import type { DDSLogoBrand, DDSLogoVariant } from "./DDSLogo";

type LogoCdnUrls = Record<DDSLogoBrand, Record<DDSLogoVariant, string>>;

export const LOGO_CDN_URLS: LogoCdnUrls = {
  classdojo: {
    lockup: "https://static.classdojo.com/img/brand/classdojo-lockup.svg",
    mark: "https://static.classdojo.com/img/brand/classdojo-mark.svg",
  },
  "dojo-tutor": {
    lockup: "https://static.classdojo.com/img/brand/dojo-tutor-lockup.svg",
    mark: "https://static.classdojo.com/img/brand/dojo-tutor-mark.svg",
  },
  "dojo-sparks": {
    lockup: "https://static.classdojo.com/img/brand/dojo-sparks-lockup.svg",
    mark: "https://static.classdojo.com/img/brand/dojo-sparks-mark.svg",
  },
  "dojo-islands": {
    lockup: "https://static.classdojo.com/img/brand/dojo-islands-lockup.svg",
    mark: "https://static.classdojo.com/img/brand/dojo-islands-mark.svg",
  },
};
